import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { Auth } from '../lib/auth';

export interface RouterContext {
  auth: Auth;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => <div className="vazio">página não encontrada</div>,
});
